/** An envelope's spending by category for its pie (TMMAPP-0108, § Overrides 1). */
import type { Envelope } from '@/api/envelopes';

export interface PieSlice {
  categoryId: number;
  name: string;
  /** The spend, as a positive amount. */
  valueMinor: number;
}

/** The envelope's spending by EXPENSE category, largest first; refunded-to-positive ones left out. */
export function spendingSlices(envelope: Envelope): PieSlice[] {
  const { items } = envelope.allTimeCategoryTotals ?? envelope.categoryTotals;
  return items
    .filter((item) => item.kind === 'EXPENSE' && item.amountMinor < 0)
    .map((item) => ({
      categoryId: item.categoryId,
      name: item.name,
      valueMinor: Math.abs(item.amountMinor),
    }))
    .sort((a, b) => b.valueMinor - a.valueMinor);
}
